import React from 'react';
import Card from 'src/components/common/Card.redesign';
import CardContainer from 'src/components/common/CardContainer.redesign';
import ContractGenerationListDto from 'src/models/leasing/ContractGenerationListDto';
import ContractProcessingCard from './ContractProcessingCard';

interface IContractProcessingComponentProps {
    selectedAgreements: Array<ContractGenerationListDto>;
}

const ContractProcessingComponent = (props: IContractProcessingComponentProps) => {
    const processingCards = (obj: ContractGenerationListDto) => {
        return (
            <div key={obj.leaseNumber}>
                <ContractProcessingCard
                    agreement={obj}
                    readonly={true}
                />
            </div>
        );
    };

    const newCard = () => {
        return (
            <CardContainer>
                {(props.selectedAgreements?.length > 0) && props.selectedAgreements.map(processingCards)}
                {(props.selectedAgreements === undefined || props.selectedAgreements?.length === 0) && (
                    <Card>
                        <div className="agreements-card">
                            <div style={{ textAlign: 'center' }}>
                                <p>No Contracts Selected!!</p>
                            </div>
                        </div>
                    </Card>
                )}
            </CardContainer>
        );
    };

    return <>{newCard()}</>;
};

export default ContractProcessingComponent;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ProcessingAndMaintenance/ContractProcessingComponent.tsx